export class ServiceProviderCategory {
    id: number;
    name_en_GB: string;
    name_de_CH: string;
    deleted_at: string;
    service_providers: [{
        id: number;
        name_de_CH: string;
        name_en_GB: string;
        application_duration_de_CH: string;
        application_duration_en_GB: string;
        category_id: number;
        subcategory_id: number;
        diagnoses_specific: string;
        company_id: number;
        description_de_CH: string;
        description_en_GB: string;
        state: string;
        zip_code: string;
        country_id: number;
        website: string;
        digital_therapy: number;
        group_therapy: number;
        pivot: {
            patient_id: number;
            service_provider_id: number;
            status: number;
            id: number;
        }
        age_group: {
            id: number;
            name_de_CH: string;
            name_en_GB: string;
            deleted_at: string;
        };
        sub_category: {
            id: number;
            name_de_CH: string;
            name_en_GB: string;
            category_id: number;
            deleted_at: string;
        };
        contraindications: [{
            id: number;
            code: string;
            name_de_CH: string;
            name_en_GB: string;
            status: boolean;
            pivot: {
                contraindication_id: number;
                service_provider_id: number;
            }
        }];
        company: {
            id: number;
            name: string;
        };
        insurance: {
            id: number;
            name_de_CH: string;
            name_en_GB: string;
            deleted_at: string;
        };
        country: {
            id: number;
            name: string;
            code: string;
            dial_codes: string;
            created_at: string;
            updated_at: string;
            deleted_at: string;
        };
    }];
}